<template>
  <div class="container">
    <template v-if="success">
      <section class="hero is-primary">
        <div class="hero-body">
          <p class="title">OK</p>
          <p class="subtitle">You can close this page.</p>
        </div>
      </section>
    </template>
    <template v-else>
      <div class="container has-text-centered">
        <div class="block">
          <b-input placeholder="PIN code" v-model="pin" @input="handleChange" type="numbrer" min="0" max="9999" :disabled="inputDisabled" />
        </div>
        <b-message v-if="submitError" type="is-danger" title="Error">Invalid PIN</b-message>
      </div>
    </template>
  </div>
</template>

<script>
  import BInput from "buefy/src/components/input/Input";
  import {mapActions} from "vuex";

  export default {
    components: {
      BInput
    },
    name: "screenrunbypin",
    data() {
      return {
        pin: '',
        success: false,
        submitError: false
      };
    },
    computed: {
      inputDisabled() {
        return this.pin.length === 4;
      }
    },
    methods: {
      ...mapActions('automations', ['runByPin']),
      handleChange() {
        this.submitError = false;

        if (this.pin.length === 4) {
          this.runByPin({
            pin: this.pin.trim(),
            target: this.$route.query.target,
            callback: (err) => {
              if (err) {
                this.submitError = true;
                this.pin = '';

                return;
              }

              this.success = true;
            }
          });
        }
      }
    },
    mounted() {
      this.pin = '';
      this.errorMessage = '';
      this.success = false;
      this.submitError = false;
    }
  }
</script>

<style scoped>
section.message-body {
  margin-top: 0.1rem;
}
</style>
